export default "__VITE_ASSET__Bb6np4tV__"